// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__JlrWZ","label":"Labeled_label__hjTu2","divider":"Labeled_divider__holxY"};